// extracted by mini-css-extract-plugin
export var alignCenter = "_8a-d";
export var bannerShown = "_8a-6";
export var buttonContent = "_8a-0";
export var cardList = "_8a-1";
export var centerContent = "_8a-2";
export var chevron = "_8a-3";
export var closePanelButton = "_8a-k";
export var conversationContextContainer = "_8a-l";
export var conversationDetailContainer = "_8a-4";
export var detailWrapper = "_8a-7";
export var dropdownButton = "_8a-e";
export var dropdownTitle = "_8a-9";
export var fullHeight = "_8a-5";
export var hidden = "_8a-a";
export var icon = "_8a-b";
export var mergeSuggestionWrapper = "_8a-m";
export var panel = "_8a-i";
export var portalButtonsWrapper = "_8a-c";
export var right = "_8a-j";
export var tableSummaryContainer = "_8a-8";
export var tableSummaryHeader = "_8a-g";
export var threeDotsButton = "_8a-f";
export var wide = "_8a-h";